import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import BasicInfo from './BasicInfo.js';
import CreatedBy from './CreatedBy.js';
import Notificacao from './Notificacao.js';
import api from "../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const classes = useStyles();

    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        cor: '',
        estado: '',
        acidente: '',
        anomalia: '',
        evento: '',

        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    const [funcoes, setFuncoes] = useState({})
    useEffect(() => {
        if (props.data) {
            let checked = {}
            for (let funcao of props.list_funcoes) {
                checked[funcao._id] = false
            }
            for (let funcao of props.data.funcoes) {
                checked[funcao._id] = true
            }
            setFuncoes(checked);
            setValues(props.data)
        }
    }, [props])

    async function Update() {
        snack.current("editando, aguarde.", { variant: 'info' })
        let my_funcoes = []
        for (let key in funcoes) {
            if (funcoes[key]) {
                my_funcoes.push(key)
            }
        }
        var update_nivelresp = {
            "_id": values._id,
            "estado": values.estado,
            "acidente": values.acidente,
            "anomalia": values.anomalia,
            "evento": values.evento,
            "funcoes": my_funcoes
        }
        api.put(`/nivelresp`, { update_nivelresp })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current("Nível de Resposta editado!", { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar Nível de Resposta!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <div className="titles">Informações Gerais e Grupos para Notificação</div>
                <div className="row">
                    <BasicInfo values={values} setValues={setValues} />
                    <Notificacao setFuncoes={setFuncoes} funcoes={funcoes} list_funcoes={props.list_funcoes} />
                </div>
                <CreatedBy values={values} setValues={setValues} />
            </DialogContent >
            <DialogActions>
                <Button
                    // disabled={disable}
                    onClick={() => { Update() }}
                >
                    Salvar
                </Button>
                <Button onClick={() => { props.setOpen(false) }}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
